import type { legal as en } from "../en/legal";
import type { Messages } from "../types";

export const legal: Messages<typeof en> = {
  nav: { privacy: "الخصوصية", terms: "الشروط", deletion: "حذف البيانات", backHome: "العودة إلى ملفك", signIn: "تسجيل الدخول" },
  updated: "آخر تحديث {{date}}",
  contactLine: "لديك سؤال عن الخصوصية أو بياناتك؟ راسلنا:",
  privacy: {
    title: "سياسة الخصوصية",
    lead: "ملفك خدمة لإدارة وسائل التواصل الاجتماعي للأعمال. توضح هذه السياسة البيانات التي نصل إليها عند ربط حساب إنستغرام، وسبب ذلك، ومدة الاحتفاظ بها، وطريقة حذفها.",
    sections: {
      who: {
        title: "من نحن",
        body: "يقدّم ملفك («نحن») صندوق وارد مشتركًا والنشر والأتمتة والتحليلات للحسابات التجارية وحسابات صنّاع المحتوى على إنستغرام، ولاحقًا على قنوات أخرى.\nالجهة التي تربط حسابًا بمنصة ملفك («المؤسسة») هي من تقرر طريقة استخدام بياناتها، ونحن نعالجها نيابةً عنها.",
      },
      data: {
        title: "بيانات إنستغرام التي نصل إليها",
        body: "عندما يربط مالك المؤسسة أو مشرفها حساب إنستغرام احترافيًا عبر تسجيل الدخول الرسمي في إنستغرام، وبالصلاحيات التي يوافق عليها فقط:\n• الملف الشخصي: معرّف الحساب واسم المستخدم والاسم وصورة الملف وعدد المتابعين ونوع الحساب.\n• المحتوى: المنشورات والريلز والمنشورات المتعددة والقصص مع النصوص وروابط الوسائط والإعجابات وعدد التعليقات.\n• التعليقات على منشورات الحساب، ومنها الردود واسم المستخدم العلني لكل معلّق.\n• الرسائل المباشرة مع الحساب في الحدود التي يسمح بها إنستغرام (أحدث رسائل كل محادثة).\n• الإحصاءات: الوصول والمشاهدات والتفاعل وإحصاءات الجمهور للحساب ومنشوراته.\nلا نتلقى كلمات مرور إنستغرام أبدًا، ولا نصل إلى حسابات إنستغرام الشخصية.",
      },
      why: {
        title: "لماذا نستخدمها",
        body: "• لعرض التعليقات والرسائل في صندوق وارد واحد ليرد عليها الفريق.\n• لتشغيل الأتمتة التي تضبطها المؤسسة (مثل إخفاء الرسائل المزعجة أو الرد على أسئلة الأسعار).\n• لنشر المحتوى الذي تجدوله المؤسسة.\n• لبناء لوحات المعلومات والتقارير من الإحصاءات.\n• لاقتراح الردود والتصنيفات بالذكاء الاصطناعي عندما تفعّله المؤسسة.\nلا نبيع البيانات، ولا نستخدمها للإعلانات، ولا نبني ملفات عن الأشخاص عبر المؤسسات.",
      },
      ai: {
        title: "المعالجة بالذكاء الاصطناعي",
        body: "عند تفعيل الذكاء الاصطناعي يُرسل نص التعليقات والرسائل عبر بوابة الذكاء الاصطناعي الخاصة بنا إلى مزوّد النموذج المعتمد في المنصة، فقط لإنتاج التصنيف أو المسودة المطلوبة. ويُمنع المزوّدون تعاقديًا من التدريب عليه. السجل المستورد عند ربط الحساب لا يشغّل الأتمتة ولا الردود التلقائية أبدًا.",
      },
      storage: {
        title: "التخزين والأمان",
        body: "• رموز الوصول إلى إنستغرام مشفّرة أثناء التخزين بمعيار AES-256-GCM، ولا تظهر أبدًا في التطبيق أو الروابط أو السجلات.\n• تُخزّن البيانات في قاعدة بياناتنا السحابية في المنطقة التي نعمل فيها، وتحميها ضوابط الوصول والنقل المشفّر (HTTPS) وسجلات تدقيق للإجراءات الحساسة.\n• الوصول داخل المؤسسة يتبع أدوارها (مالك، مشرف، محرر، مشاهد).",
      },
      retention: {
        title: "مدة الاحتفاظ",
        body: "• افتراضيًا تحتفظ المؤسسة بالتعليقات والرسائل والمنشورات المستوردة إلى أن تحذفها، أو تفصل الحساب وتمحو بياناته، أو تغلق المؤسسة.\n• يمكن لمشرفي المؤسسة تحديد مدة احتفاظ (مثل 90 يومًا) تُحذف بعدها التعليقات والرسائل الأقدم تلقائيًا.\n• عند فصل الحساب يُحذف رمز الوصول الخاص به فورًا.",
      },
      deletion: {
        title: "حذف بياناتك",
        body: "• أزل ملفك من إنستغرام ← الإعدادات ← التطبيقات والمواقع. يُبلغنا إنستغرام فنفصل الحساب ونحذف رمز الوصول.\n• اطلب الحذف من شاشة «التطبيقات والمواقع» في إنستغرام أو راسلنا. نمحو منشورات الحساب وتعليقاته ورسائله وجهات الاتصال المرتبطة، ونعطيك رمز تأكيد لمتابعة الحالة على {{url}}.\n• داخل ملفك يستطيع المشرفون تصدير أو محو كل ما هو مخزّن عن شخص واحد (معلّق أو جهة اتصال).",
      },
      sharing: {
        title: "المشاركة",
        body: "لا نشارك البيانات إلا مع مزوّدي البنية التحتية الذين يشغّلون ملفك لصالحنا (الاستضافة وقاعدة البيانات وبوابة الذكاء الاصطناعي) وفق شروط معالجة البيانات، أو عندما يفرض القانون ذلك. لا نبيع البيانات الشخصية أبدًا.",
      },
      rights: {
        title: "حقوقك",
        body: "بحسب مكان إقامتك يمكنك طلب الوصول إلى بياناتك أو تصحيحها أو تصديرها أو حذفها، أو الاعتراض على معالجتها. ويمكن للمعلّقين والعملاء الذين راسلوا جهة تجارية التواصل معها أو معنا مباشرة.",
      },
      contact: {
        title: "التواصل",
        body: "أسئلة وطلبات الخصوصية: {{email}}. نرد خلال 30 يومًا.",
      },
    },
  },
  terms: {
    title: "شروط الخدمة",
    lead: "تحكم هذه الشروط استخدام الأعمال وفرقها لملفك. بإنشاء مؤسسة أو ربط حساب فإنك توافق عليها.",
    sections: {
      service: {
        title: "الخدمة",
        body: "يساعد ملفك الفرق على إدارة حسابات التواصل الاجتماعي: صندوق وارد مشترك للتعليقات والرسائل، والنشر، والأتمتة، والردود بمساعدة الذكاء الاصطناعي، والتحليلات. قد تتغير الميزات بتغيّر واجهات برمجة القنوات.",
      },
      accounts: {
        title: "مؤسستك وحساباتك",
        body: "• يجب أن تكون مخوّلًا بإدارة كل حساب تربطه، وأن تربط حسابات إنستغرام الاحترافية فقط (تجارية أو صانع محتوى).\n• أنت مسؤول عن أعضاء فريقك وأدوارهم وما ينشرونه أو يرسلونه عبر ملفك.\n• حافظ على أمان بيانات الدخول وأبلغنا عن أي استخدام غير مصرّح به.",
      },
      platforms: {
        title: "قواعد المنصات",
        body: "استخدام ملفك مع إنستغرام يعني أيضًا الالتزام بشروط Meta وسياساتها، ومنها نافذة المراسلة وحدود النشر. يطبّق ملفك هذه الحدود وقد يرفض الإجراءات التي تخالفها.",
      },
      acceptable: {
        title: "الاستخدام المقبول",
        body: "لا تستخدم ملفك لإرسال رسائل مزعجة أو مضايقة الناس أو نشر محتوى مخالف للقانون أو جمع بيانات لا يحق لك الوصول إليها أو محاولة تعطيل الخدمة أو إثقالها.",
      },
      ai: {
        title: "ميزات الذكاء الاصطناعي",
        body: "قد تخطئ اقتراحات الذكاء الاصطناعي. القواعد التي تضبطها على «تلقائي» تعمل دون مراجعة؛ استخدم وضع الموافقة إن أردت أن يراجع شخص كل رد. تبقى مسؤولًا عما يُرسل من حساباتك.",
      },
      data: {
        title: "البيانات",
        body: "مؤسستك تملك محتواها. نعالجه لتقديم الخدمة كما هو موضح في سياسة الخصوصية، ونحذفه كما هو موضح فيها.",
      },
      availability: {
        title: "التوفر والتغييرات",
        body: "نعمل على إبقاء ملفك متاحًا لكن لا نضمن عدم انقطاعه، خاصة عند تعطل واجهة برمجة إحدى القنوات. قد نحدّث هذه الشروط، وسنعلن التغييرات الجوهرية داخل التطبيق.",
      },
      liability: {
        title: "المسؤولية",
        body: "في الحدود التي يسمح بها القانون، يُقدَّم ملفك «كما هو» وتقتصر مسؤوليتنا على الرسوم المدفوعة للخدمة خلال الاثني عشر شهرًا السابقة.",
      },
      termination: {
        title: "الإنهاء",
        body: "يمكنك فصل الحسابات أو إغلاق مؤسستك في أي وقت. وقد نعلّق المؤسسات التي تخالف هذه الشروط.",
      },
      contact: {
        title: "التواصل",
        body: "أسئلة حول هذه الشروط: {{email}}.",
      },
    },
  },
  deletion: {
    title: "حذف البيانات",
    lead: "كيف تحذف بيانات إنستغرام التي يحتفظ بها ملفك، وحالة طلب الحذف.",
    statusTitle: "حالة الطلب",
    code: "رمز التأكيد",
    requested: "تاريخ الطلب",
    completed: "تاريخ الاكتمال",
    pending: "لم يكتمل بعد",
    status: {
      received: "تم الاستلام",
      in_progress: "قيد التنفيذ",
      completed: "مكتمل",
      failed: "يحتاج إلى متابعة",
    },
    statusHint: {
      received: "استلمنا طلبك وسنبدأ قريبًا.",
      in_progress: "نمحو البيانات الآن. تتحدّث هذه الصفحة عند الانتهاء.",
      completed: "مُحي كل ما كان يحتفظ به ملفك لحساب إنستغرام هذا.",
      failed: "توقف الحذف لسبب ما. أُبلغ فريقنا وسيكمله، ويمكنك أيضًا مراسلتنا.",
    },
    summaryTitle: "ما تم محوه",
    counts: {
      accounts: "الحسابات المربوطة",
      posts: "المنشورات",
      comments: "التعليقات",
      conversations: "المحادثات",
      messages: "الرسائل",
      contacts: "جهات الاتصال",
    },
    notFound: "لم نجد طلبًا بهذا الرمز. تحقق من الرمز الذي وصلك من إنستغرام أو راسلنا.",
    invalidCode: "لا يبدو هذا رمز تأكيد صالحًا.",
    loadFailed: "تعذّر تحميل الحالة الآن. حاول مجددًا.",
    retry: "حاول مجددًا",
    howTitle: "كيف تطلب الحذف",
    how: "• في تطبيق إنستغرام افتح الإعدادات ← التطبيقات والمواقع، واختر ملفك ثم أزله. يُبلغنا إنستغرام فنفصل الحساب ونحذف رمز الوصول.\n• من الشاشة نفسها يمكنك أن تطلب من إنستغرام إرسال طلب حذف بيانات إلينا. ستحصل على رمز تأكيد: افتح هذه الصفحة به لمتابعة الحالة.\n• أو راسلنا على {{email}} من عنوان يمكننا التحقق منه، مع اسم مستخدمك في إنستغرام.",
    lookupLabel: "تحقّق من رمز تأكيد",
    lookup: "عرض الحالة",
  },
};
